var React = require('react');

function HeaderGrassLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"enableBackground":"new"},React.createElement("path",{"transform":"matrix(1,0,0,1,-73.92969,-216.38059)","d":"M 336.15983 341.1576 C 327.8173 304.7937 303.7923 278.52864 275.4523 278.52864 C 266.5794 278.52864 258.10868 281.1106 250.4112 285.84339 C 232.54496 239.60991 196.02564 210.01094 155.26902 217.55104 C 110.67338 225.80223 77.149898 279.3932 73.97143 343.1975 C 73.96366 343.36659 73.95394 343.53364 73.946178 343.70075 C 73.65864 349.83619 77.08578 355.0196 81.40858 355.0196 L 329.0141 355.0196 C 334.0713 355.0196 337.7296 347.9944 336.15983 341.1576 Z ","fill":"#04756f"})));
}

HeaderGrassLeft.defaultProps = {"version":"1.1","width":"263pt","height":"139pt","viewBox":"0 0 263 139"};

module.exports = HeaderGrassLeft;

HeaderGrassLeft.default = HeaderGrassLeft;
